"use strict";
// Kept apart from the cleanup itself so the sign-out thunk can cancel retries without importing fileApi, which
// would form a cycle through baseQueryWithReauth.
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduledRetries = void 0;
exports.cancelDiscardRetries = cancelDiscardRetries;
exports.getSessionGeneration = getSessionGeneration;
// Lives outside any component so a cleanup that failed is still retried after the picker that started it unmounts.
var scheduledRetries = new Map();
exports.scheduledRetries = scheduledRetries;
// Bumped on sign-out so a request still in flight for the previous user never schedules another attempt.
var sessionGeneration = 0;
function getSessionGeneration() {
    return sessionGeneration;
}
function cancelDiscardRetries() {
    sessionGeneration += 1;
    scheduledRetries.forEach(function (retryTimer) { return clearTimeout(retryTimer); });
    scheduledRetries.clear();
}
